import {
    AccountModel,
    GetOwnedPropertiesAccountInput, GetRightOfUseListInputRest,
    GetRightToSignListInput, NewGetPropertiesWithRightOfUseAccountInput,
    RightOfUseApi
} from "~/gen/openapi/portalService";
import {useQuery} from "@tanstack/vue-query";

export const useRightOfUseService = () => {
    const {$axios, $config} = useNuxtApp()
    const rightOfUseApi = new RightOfUseApi(undefined, $config.public.apiBaseHost, $axios)

    const propertiesWithRightOfUseAccountQuery = (input: NewGetPropertiesWithRightOfUseAccountInput) => useQuery({
        queryKey: ['rightOfUseGetPropertiesWithRightOfUseAccount', input.AccountIdCrm],
        queryFn: async () => {
            return (await rightOfUseApi.rightOfUseGetPropertiesWithRightOfUseAccount(input)).data
        },
        staleTime: 30 * 60 * 1000,
        refetchOnWindowFocus: false
    })

    return {
        propertiesWithRightOfUseAccountQuery
    }
}